import React from "react";
var __jsx = React.createElement;
import { SegmentedControl } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
/** Pill-style segmented tab bar with a single highlighted active segment. */
export function SegmentedTabs(_ref) {
  var items = _ref.items,
    activeId = _ref.activeId,
    _onChange = _ref.onChange,
    testIdPrefix = _ref.testIdPrefix,
    ariaLabel = _ref.ariaLabel;
  var data = items.map(function (item) {
    return {
      value: item.id,
      label: /*#__PURE__*/React.createElement("span", {
        "data-testid": "".concat(testIdPrefix, "-").concat(item.id),
        className: "inline-flex items-center justify-center gap-2"
      }, item.icon ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: item.icon,
        className: "w-3.5 h-3.5"
      }) : null, item.label)
    };
  });
  return /*#__PURE__*/React.createElement(SegmentedControl, {
    fullWidth: true,
    "aria-label": ariaLabel,
    value: activeId,
    onChange: function onChange(value) {
      return _onChange(value);
    },
    data: data,
    transitionDuration: 0,
    styles: {
      control: {
        "&:not(:first-of-type)": {
          borderColor: "transparent"
        }
      }
    },
    classNames: {
      root: "rounded-sds-300 border border-sds-base-default bg-sds-base-secondary text-sds-base-secondary",
      label: "rounded-sds-200 px-4 py-2 text-style-body-small-strong hover:text-sds-base-default",
      labelActive: "text-sds-brand-default",
      active: "rounded-sds-200 border-2 border-teal-400 dark:border-teal-300 bg-sds-base-default shadow-sds-200"
    }
  });
}